import * as React from 'react';

import { Controller } from 'react-hook-form';
import { Checkbox } from '@teamsnap/snap-ui';
import { Notice } from './Notice';

type Props = {
  form: any;
  options: any;
  submitting: boolean;
  autoRosteringIsEnabled: boolean;
};

const DuplicateOptionLabels = {
  REGISTRATION_OPTIONS: 'Registration Options',
  PARTICIPANT_GROUPS: 'Group Name(s)',
  REGISTRATION_FEES: 'Registration Fee(s)',
  ELIGIBILITY_RULES: 'Eligibility Rules',
  CAPACITY_LIMIT_AND_WAITLIST: 'Capacity Limit and Waitlist',
  FORM_BUILDER: 'Form Builder',
  QUESTIONS_AND_LOGIC: 'Questions & Logic',
  DIGITAL_AGREEMENTS: 'Digital Agreements',
  CHECKOUT_SETTINGS: 'Checkout Settings',
  INSTALLMENT_PLANS: 'Payment plan(s)',
  DISCOUNTS: 'Discount(s)',
  ADDONS: 'Add-ons',
  CONFIRMATION_MESSAGE: 'Confirmation Message',
};

const DuplicateOptions = ({ form, options, submitting, autoRosteringIsEnabled }: Props) => {
  if (autoRosteringIsEnabled) {
    DuplicateOptionLabels.ELIGIBILITY_RULES = 'Eligibility and Rostering';
  }

  const { control, getValues, watch } = form;

  const fields = watch();

  const renderSettingsOptions = () => (
    <div data-testid="DuplicateOptions--container">
      {options.map((option, index) => (
        <React.Fragment key={`DuplicateOptions-${option}-${index}`}>
          <Controller
            name={option.name}
            control={control}
            disabled={option.disabled || submitting}
            as={
              <Checkbox
                label={DuplicateOptionLabels[option.name.toUpperCase()]}
                name={option.name}
                className={'sui-mt-1'}
                isPartial={option.isPartial}
                extraProps={{
                  input: {
                    value: option.name,
                    checked: getValues(option.name),
                    onChange: option.onChange,
                    'data-testid': `DuplicateOptions--option-${option.name}`,
                  },
                }}
              />
            }
          />
          {option?.children && option?.children?.length > 0 && (
            <div className="sui-pl-3">
              {option.children.map((child, index) => (
                <React.Fragment key={`${child}[${index}]`}>
                  <Controller
                    name={child.name}
                    control={control}
                    disabled={child.disabled || submitting}
                    as={
                      <Checkbox
                        label={DuplicateOptionLabels[child.name.toUpperCase()]}
                        name={child}
                        className={'sui-mt-1'}
                        extraProps={{
                          input: {
                            value: child.name,
                            checked: getValues(child.name),
                            onChange: child.onChange,
                            'data-testid': `DuplicateOptions--option-${child.name}`,
                          },
                        }}
                      />
                    }
                  />
                </React.Fragment>
              ))}
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  );

  return (
    <>
      <h2 className="sui-heading-sm sui-leading-none sui-mb-2">Select settings to be copied over</h2>
      <Notice
        sentiment="info"
        subtitle={
          <>
            {fields.participant_groups === false ? (
              <ul className="sui-pl-1">
                <li>
                  For enhanced financial security, deposit account selections cannot be copied from form to form. Please
                  reselect the desired deposit account in the new form.
                </li>
                <li>Option-based logic will not be copied because registration options are not selected.</li>
              </ul>
            ) : (
              <>
                For enhanced financial security, deposit account selections cannot be copied from form to form. Please
                reselect the desired deposit account in the new form.
              </>
            )}
          </>
        }
        className="sui-mb-2"
      />
      <div>{renderSettingsOptions()}</div>
    </>
  );
};

export default DuplicateOptions;
